export default __webpack_public_path__ + "static/media/ltw.c09d5c2c.jpg";